// extracted by mini-css-extract-plugin
module.exports = {"trigger":"AdvertiserDisclosure_trigger__ab7Vt","trigger-with-background":"AdvertiserDisclosure_trigger-with-background__pgsm_"};